import template from './house-condition.jade';
import houseConditionTypes from '../../../enums/house-condition-type';
import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
  .module('cian.addForm.aboutHouseHouseCondition', [])
  .directive('cianAfAboutHouseHouseCondition', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller($scope, adTooltipsService, analyticsService, popupService, deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.items = houseConditionTypes;

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'condition',
        trackingLabel: 'house-condition-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
    controllerAs: 'houseCondition',
    template,
  })).name;
